const generalInfo = {
  about: {
    title: "About Me",
    content: [
      "Hi! I'm Leo, a software engineer with 7+ years of experience in web technologies.",
      "I'm a full-stack developer specializing in scalable automation services and SDET-focused testing frameworks using modern tools.",
      "Outside of work, I enjoy cars, motorcycles, FPS games, snowboarding, and sightseeing.",
      "I enjoy working on small, collaborative teams where I can contribute to quality-driven development, and if you come across any opportunities where you think I’d be a great fit, feel free to reach out.",
    ],
  },
  experience: {
    title: "Work Experience",
    content: [
      {
        company: "Walmart Global Tech - SDET - Nov 2023 – Current",
        details: [
          "Created and executed manual & automation tests, conducted periodic measurement analysis. Delivered, and communicated test results.",
          "Designed and implemented functional and end-to-end tests working at UI, API and database levels.",
          "Contributed to planning and estimation activities, including monitoring processes and reviewing QA deliverables and tasks.",
        ],
      },
      {
        company: "Visa - Sr. Software Test Engineer - April 2022 – August 2023",
        details: [
          "Created & executed test plans, test designs & test cases covering feature integration, regression, and system level testing.",
          "Contributed to API & UI functional automation frameworks using industry wide tools and performed database testing on RDMBS & NoSQL based databases.",
          "Helped debug Linux/Unix/Container based application servers in Docker/Kubernetes.",
        ],
      },
      {
        company:
          "Extron Electronics - Automation Engineer - Nov 2020 – Nov 2021",
        details: [
          "Developed a software support dashboard used to execute 10,000 accessibility tests.",
          "Created & configured a HAPROXY load balancer for network distribution.",
          "Created & configured an Application Portal (layer 7) load balancer for Azure VMs.",
          "Created scripts to automate database migrations and deployment cleanups.",
          "Created multiple accessibility microservices with over 500 downloads on docker hub.",
          "Provided guidance to team members with strategies to help improve code optimization.",
        ],
      },
      {
        company:
          "Glidewell Dental Labs - QA Automation Engineer - Apr 2018 – Apr 2020",
        details: [
          "Designed and built an automation framework used to test both UIs and services.",
          "Set up CI/CD pipelines using Jenkins, Docker & AWS to automate the execution of test builds.",
          "Developed a software support tool used to run selenium tests and restart services.",
        ],
      },
      {
        company: "Software Engineer - DiagnosisAI - Feb 2017 - Oct 2018",
        details: [
          "Contributed to the development effort of an automated doctor to patient service.",
          "Contributed to the development effort of the company's landing page.",
        ],
      },
      {
        company:
          "Sony Pictures Entertainment - Automation Analyst - Sep 2017 – Apr 2018",
        details: [
          "Contributed to the development effort of a Java/Python automation framework.",
          "Developed automation tests for web apps, REST APIs, thick clients, and other applications.",
          "Collaborated with offshore developers for requirements gathering & framework development.",
        ],
      },
    ],
  },
  projects: {
    title: "My Projects",
    content: [
      {
        name: "Auto Apply (Auto Apply to Jobs on LinkedIn)",
        link: "https://github.com/yuxli066/HashiramaSenju",
      },
      { name: "Del Rosa Massage", link: "https://delrosamassage.co" },
      { name: "Mom's Recipe Book", link: "https://asianmomrecipes.com/" },
      {
        name: "Bunny Battler",
        link: "https://github.com/yuxli066/DanzoShimura",
      },
      { name: "Clueless", link: "https://github.com/yuxli066/Clueless" },
      { name: "Stoxbot", link: "https://github.com/yuxli066/stoxbot" },
      { name: "IdentifyAI", link: "https://x.com/identifyai" },
      {
        name: "Twitter Sentiment Analyzer",
        link: "https://github.com/yuxli066/TwitterSentimentAnalyzer",
      },
      { name: "RC Auto Car", link: "https://github.com/yuxli066/RC-AUTO-Car" },
    ],
  },
  contact: {
    title: "Contact Me",
    content: {
      email: "leoli7405@gmail.com",
      linkedin: "https://www.linkedin.com/in/li-leo/",
      github: "https://github.com/yuxli066",
      resume:
        "https://drive.google.com/file/d/1vOrvMbCCfWm4WXGuTCZC8N4qwXTFzPMY/view?usp=sharing",
    },
  },
};

export default generalInfo;
